module.exports = __webpack_public_path__ + "media/onboard/devices-759a526c.png";